import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// La landing comercial (pages/LandingPage.js) está aparcada: la web pública es
// manklar.com. La raíz lleva al login, salvo las URLs /?ref=CODIGO que ya se
// hayan compartido (la antigua redirección de /ref/:code las dejaba en la
// barra del navegador), que van a la página de referido.
export default function RootRedirect() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('ref');

  if (code) {
    return <Navigate to={`/ref/${encodeURIComponent(code)}`} replace />;
  }
  return <Navigate to="/login" replace />;
}
